export const setSearchParam = (params: URLSearchParams, key: string, value: string | null) => {
  if (!value) {
    params.delete(key);
  } else {
    params.set(key, value);
  }
};
